/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".audit-change-title[_ngcontent-%COMP%]{margin-top:1em;margin-bottom:-.5em}ui-json-formatter[_ngcontent-%COMP%]:not(.expandable){margin-left:28px}"];
export { styles as styles };
